import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FullScreenComponent } from './layout/full-screen/full-screen.component';
// import { AuthGuardService } from 'src/services/auth-guard.service';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: '4m', loadChildren: () => import('./four-m/four-m.module').then(f => f.FourMModule) },
      { path: 'assembly', loadChildren: () => import('./assembly/assembly.module').then(a => a.AssemblyModule) },
      { path: 'trade-item', loadChildren: () => import('./trade-item/trade-item.module').then(t => t.TradeItemModule) },
      { path: 'consigned-material', loadChildren: () => import('./consigned-material/consigned-material.module').then(c => c.ConsignedMaterialModule) },
      { path: 'defect-management', loadChildren: () => import('./defect-management/defect-management.module').then(d => d.DefectManagementModule) },
      { path: 'nonconformance', loadChildren: () => import('./nonconformance/nonconformance.module').then(n => n.NonconformanceModule) },
      { path: 'packing-slip', loadChildren: () => import('./packing-slip/packing-slip.module').then(p => p.PackingSlipModule) },
      { path: 'purchase', loadChildren: () => import('./purchase/purchase.module').then(p => p.PurchaseModule) },
      { path: 'product-plan', loadChildren: () => import('./product-plan/product-plan.module').then(p => p.ProductPlanModule) },
      { path: 'product-mrp', loadChildren: () => import('./product-mrp/product-mrp.module').then(p => p.ProductMrpModule) },
      { path: 'invent-trans', loadChildren: () => import('./invent-trans/invent-trans.module').then(i => i.InventTransModule) },
      { path: 'trade-performance', loadChildren: () => import('./trade-performance/trade-performance.module').then(t => t.TradePerformanceModule) },
      { path: 'direct-delivery', loadChildren: () => import('./direct-delivery/direct-delivery.module').then(d => d.DirectDeliveryModule) },
      { path: 'notice', loadChildren: () => import('./notice/notice.module').then(n => n.NoticeModule) },
      { path: 'receipt-confirm', loadChildren: () => import('./receipt-confirm/receipt-confirm.module').then(r => r.ReceiptConfirmModule) },
      { path: 'tax-invoice', loadChildren: () => import('./tax-invoice/tax-invoice.module').then(t => t.TaxInvoiceModule) },
      { path: 'admin', loadChildren: () => import('./admin/admin.module').then(a => a.AdminModule) }
    ]
  },
  {
    path: 'account',
    component: FullScreenComponent,
    children: [
      { path: '', loadChildren: () => import('./account/anonymous/anonymous.module').then(a => a.AnonymousModule) },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
